import { render, staticRenderFns } from "./waterfall.vue?vue&type=template&id=5dd162bc&scoped=true&"
import script from "./waterfall.vue?vue&type=script&lang=js&"
export * from "./waterfall.vue?vue&type=script&lang=js&"
import style0 from "./waterfall.vue?vue&type=style&index=0&id=5dd162bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd162bc",
  null
  
)

export default component.exports